<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="mdSignin" role="dialog">
      <form @submit.prevent="login">
        <div class="modal-dialog">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header bg-blue p-2 d-inline-block">
              <h4 class="modal-title text-uppercase m-0 color-white font-size-18 font-weight-bold">Đăng nhập</h4>
              <button type="button" class="close color-white" data-dismiss="modal"
                      style="opacity: 1; position: absolute; right: 0.5rem; top: 0.5rem;">&times;</button>
            </div>
              <div class="modal-body">
                <p>Đăng nhập để sử dụng đầy đủ các chức năng</p>
                <p>
                  <input type="number" name="phone" placeholder="Nhập số điện thoại"
                         v-model="user.phone" oninput="this.value = this.value.replace (/[^\\\\0-9]/g, ''); this.setCustomValidity('')"
                         class="form-control border-radius" required
                         oninvalid="this.setCustomValidity('Vui lòng nhập số điện thoại')"
                         autocomplete="off"/>
                </p>

                <p>
                  <input type="password" name="password" placeholder="Nhập mật khẩu"
                         v-model="user.password"
                         class="form-control border-radius" required
                         oninvalid="this.setCustomValidity('Vui lòng nhập mật khẩu')"
                         oninput="this.setCustomValidity('')"
                         autocomplete="off"/>
                </p>

                <p>
                  <button type="submit" class="btn pt-2 pb-2 pl-4 pr-4 bg-orange-2 border-radius color-white">Đăng nhập</button>
                </p>
              </div>
              <div class="modal-footer p-2 d-inline-block">
                <p class="float-left d-inline-block ml-1">
                  <a data-dismiss="modal" data-toggle="modal" data-target="#mdForgetPassword" class="color-text">Quên mật khẩu ?</a>
                </p>

                <p class="float-right d-inline-block mr-1">
                  <a data-dismiss="modal" data-toggle="modal" data-target="#mdRegister" class="color-text">Chưa có tài khoản ?</a>
                </p>
              </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal fade" id="mdForgetPassword" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content" style="height: 10rem;">
          <div class="modal-header bg-blue p-2">
            <h4 class="modal-title text-uppercase m-0 color-white font-size-18 font-weight-bold">Quên mật khẩu</h4>
            <button type="button" class="close color-white" data-dismiss="modal" style="opacity: 1;">&times;</button>
          </div>
          <div class="modal-body">
            <p class="font-size-14">Quý khách vui lòng soạn:</p>
            <p>
              <span class="color-blue font-size-18 font-weight-bold">MK</span>
              <span> gửi</span>
              <span class="color-blue font-size-18 font-weight-bold">1082</span>
              <span> để lấy mật khẩu</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mdRegister" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-blue p-2">
            <h4 class="modal-title text-uppercase m-0 color-white font-size-18 font-weight-bold">Đăng ký</h4>
            <button type="button" class="close color-white" data-dismiss="modal" style="opacity: 1;">&times;</button>
          </div>
          <div class="modal-body">
            <p>Quý khách vui lòng soạn:</p>
            <p>
              <span class="color-blue font-size-18 font-weight-bold">DK Q1</span>
              <span> gửi</span>
              <span class="color-blue font-size-18 font-weight-bold">1082</span>
              <span> để đăng ký dịch vụ gói ngày</span>
            </p>

            <p>
              <span class="color-orange font-size-18 font-weight-bold">DK Q7</span>
              <span> gửi</span>
              <span class="color-blue font-size-18 font-weight-bold">1082</span>
              <span> để đăng ký dịch vụ gói tuần</span>
            </p>

            <p>
              <span class="color-red font-size-18 font-weight-bold">DK Q30</span>
              <span> gửi</span>
              <span class="color-blue font-size-18 font-weight-bold">1082</span>
              <span> để đăng ký dịch vụ gói tháng</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="mdRegister2" role="dialog">
      <div class="modal-dialog">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header bg-blue p-2">
            <h4 class="modal-title text-uppercase m-0 color-white font-size-18 font-weight-bold">Đăng ký</h4>
            <button type="button" class="close color-white" data-dismiss="modal" style="opacity: 1;">&times;</button>
          </div>
          <div class="modal-body">
            <p>Quý khách vui lòng click vào link dưới để đăng ký:</p>
            <p>
              <a @click="registerProcess('DK Q1', 'Q1')">
                <span>Đăng ký gói ngày </span>
                <span class="color-blue font-size-18 font-weight-bold">Q1</span>
              </a>
            </p>

            <p>
              <a @click="registerProcess('DK Q7', 'Q7')">
                <span>Đăng ký gói tuần </span>
                <span class="color-orange font-size-18 font-weight-bold">Q7</span>
              </a>
            </p>

            <p>
              <a @click="registerProcess('DK Q30', 'Q30')">
                <span>Đăng ký gói tháng </span>
                <span class="color-red font-size-18 font-weight-bold">Q30</span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div id="modalAlert" class="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-blue p-2">
            <h4 class="modal-title color-white font-size-18 font-weight-bold">{{ modalTitle }}</h4>
            <button type="button" class="close color-white" style="opacity: 1;" data-dismiss="modal">&times;</button>
          </div>

          <div class="modal-body">
            <div v-html="modalMessage"></div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">Đóng</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Signin",
    data () {
      return {
        user: {
          "phone": "",
          "password": ""
        },
        modalTitle: "Thông báo",
        modalMessage: null
      }
    },
    created () {

    },
    methods: {
      closeModal(mdClose, mdOpen){
        $("#" + mdClose).modal("hide");
        setTimeout(() => {
          $("#" + mdOpen).modal("show");
        }, 3500);
      },
      login(){
        if (this.user.phone !== '' && this.user.password !== '') {
          axios.post(api.login, { phone: this.user.phone, password: md5(this.user.password) })
            .then(response => {
              var res = response.data.result;
              if (!Array.isArray(res) || !res.length) {
                this.modalMessage = "Thông tin đăng nhập không đúng, vui lòng kiểm tra lại";
                $("#modalAlert").modal("show");
              } else {
                this.$session.start();
                this.$session.set('userInfo', {'user': res[0].username, 'token': res[0].token});

                //Lấy thông tin gói cước khách hàng đăng ký
                axios.get(api.checkRegister + "?msisdn=" + res[0].username)
                  .then(response => {
                    var resCheck = response.data.result;
                    if(resCheck.length == 0){
                      //Nếu null
                      this.$session.set("isRegisted", false);
                    } else{
                      //Check xem Status kết quả trả về có chứa status = 1 hoặc status = 0 thì đã đăng ký
                      let statusArr = resCheck.filter(item => {
                        return item.Status == 1 || item.Status == 0;
                      });
                      if(statusArr.length > 0){
                        this.checkRegisted = true;
                        this.$session.set("isRegisted", true);
                      } else {
                        this.checkRegisted = false;
                        this.$session.set("isRegisted", false);
                      }

                      //Lấy thông tin tên gói để hiển thị lên Popup Khi click vào số điện thoại
                      this.$session.set('packageName', statusArr);

                      return 'success';
                    }//End If ResCheck.Length
                  })
                  .then(response => {
                    //Về trang chủ
                    //window.location.href = "/";
                    //this.$router.push("/");
                  })
                  .catch(e => {
                    console.log(e);
                  })

                //Trở về trang chủ sau khi login thành công
                //this.$router.push('/');
                window.location.href = "/";
              }
            })
            .catch(e => {
              this.modalMessage = "Xảy ra lỗi khi đăng nhập";
              $("#modalAlert").modal("show");
              console.log("Login------");
              console.log(e);
            });
        } else {
          alert('User and Password must be present')
        }
        return false;
      },

      registerProcess(commandCode, packageCode){
        axios.post(api.register, JSON.stringify({ commandCode: commandCode, packageCode: packageCode }))
          .then(response => {
            var res = response.data.result;
            if(res.indexOf("http") > -1){
              window.location.href = res;
            }
          })
          .catch(e => {

          })
      }
    }
  }
</script>

<style scoped>
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .modal-body{
    padding: 0.5rem 1rem 0 1rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Signin.vue